import type { TFunction } from 'i18next'

/**
 * « 0 an / 10 ans » under the commissioning year: age over expected lifespan,
 * each side pluralised in the reader's language (never a literal « y »).
 */
export function formatAgeOverLifespan(t: TFunction, age: number, lifespan: number): string {
  return t('equipment_tab.row.age_over_lifespan', {
    age: t('equipment_tab.row.years', { count: age }),
    lifespan: t('equipment_tab.row.years', { count: lifespan }),
  })
}
